// extracted by mini-css-extract-plugin
module.exports = {"Loader":"Spinner_Loader__Zzi5I","load5":"Spinner_load5__1SYvZ"};